import pino from 'pino'
// @ts-ignore
import cloudwatch from 'pino-cloudwatch'

const isLocalEnv = process.env.NEXT_PUBLIC_APP_ENV === 'local'

// If in local env, send to stdout
const destination = isLocalEnv
  ? process.stdout
  : cloudwatch({
      group: process.env.CLOUDWATCH_GROUP || 'sphere-prod-logs',
      stream: process.env.CLOUDWATCH_STREAM || 'sphere-next-stream',
      interval: 5000,
      aws_region: 'us-east-1'
    })

const logger = pino({ level: 'info' }, destination)

export default logger
